export const ErrUserBeenUsed = 560;
export const ErrEmailorPhoneBeenUsed = 561;
export const ErrVerificationCode = 562;
export const ErrPwdTooShort = 563;
export const ErrEmailInvalid = 564;

